var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.708 24H3.29204C1.49782 24 0 22.5022 0 20.708V18.3717H0.637168V20.708C0.637168 22.1548 1.84529 23.3628 3.29204 23.3628H20.708C22.155 23.3628 23.3628 22.155 23.3628 20.708V3.29204C23.3628 1.84465 22.1553 0.637168 20.708 0.637168H17.9469V0H20.708C22.5022 0 24 1.49782 24 3.29204V20.708C24 22.5022 22.5022 24 20.708 24ZM0.637168 17.9469H0V17.3097H0.637168V17.9469ZM0.637168 16.885H0V3.29204C0 1.49782 1.49782 0 3.29204 0H17.5221V0.637168H3.29204C1.84497 0.637168 0.637168 1.84492 0.637168 3.29204V16.885Z",
    fill: "#204B90"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9999,
    cy: 12,
    r: 4.96903,
    stroke: "#204B90"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8584,
    cy: 4.14151,
    r: 0.986726,
    stroke: "#204B90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b195ab97.svg";
export { ForwardRef as ReactComponent };